export default {
    namespaced: true,
    state: {
        activeId: null,
        menuVersion: 3,
    },
    getters: {
        ['getActiveId'](state) {
            return state.activeId;
        },
        ['getMenuVersion'](state) {
            return state.menuVersion
        }
    }
    ,
    mutations: {
        setActiveId(state, activeId) {
            state.activeId = activeId;
        },
        setMenuVersion(state, menuVersion) {
            state.menuVersion = menuVersion;
        }
    }
}
